var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsIn, IsInt, Min, ValidateIf } from 'class-validator';
export const workspacePath = ({ workspace_type, workspace_id, }) => `${workspace_type}/${workspace_id}`;
export const WORKSPACE_PATH = ':workspace_type/:workspace_id';
export const LINK_PATH = ':workspace_type/:link_id';
class WorkspaceTypeDto {
    workspace_type;
}
__decorate([
    IsIn(['site', 'channel']),
    __metadata("design:type", String)
], WorkspaceTypeDto.prototype, "workspace_type", void 0);
export class AccountLikeDescriptorDto {
    account_like_type;
    account_like_id;
}
__decorate([
    IsIn(['site', 'channel', 'advertiser_account']),
    __metadata("design:type", String)
], AccountLikeDescriptorDto.prototype, "account_like_type", void 0);
__decorate([
    Min(1),
    IsInt(),
    __metadata("design:type", Number)
], AccountLikeDescriptorDto.prototype, "account_like_id", void 0);
export class WorkspaceDescriptorDto extends WorkspaceTypeDto {
    workspace_id;
}
__decorate([
    Min(1),
    IsInt(),
    __metadata("design:type", Number)
], WorkspaceDescriptorDto.prototype, "workspace_id", void 0);
export class LinkDescriptorDto extends WorkspaceTypeDto {
    link_id;
}
__decorate([
    Min(1),
    IsInt(),
    __metadata("design:type", Number)
], LinkDescriptorDto.prototype, "link_id", void 0);
export class WorkspaceWithLinkDescriptorDto extends LinkDescriptorDto {
    workspace_id;
}
__decorate([
    Min(1),
    IsInt(),
    __metadata("design:type", Number)
], WorkspaceWithLinkDescriptorDto.prototype, "workspace_id", void 0);
export class AdvertiserAccountIdDto {
    advertiser_account_id;
}
__decorate([
    IsInt(),
    ValidateIf((_, value) => value !== null),
    __metadata("design:type", Object)
], AdvertiserAccountIdDto.prototype, "advertiser_account_id", void 0);
//# sourceMappingURL=shared.js.map